import { useState } from "react";
import { Globe } from "lucide-react";
import { LANGUAGES, applyLanguage, currentLanguage, markLanguagePicked } from "@/lib/i18n";

export default function LanguageSwitcher({ dark = false, testid = "language-switcher" }) {
  const [lang, setLang] = useState(currentLanguage());
  const change = (e) => {
    setLang(e.target.value);
    if (!localStorage.getItem("iot_token")) markLanguagePicked();
    applyLanguage(e.target.value);
  };
  return (
    <label className={`flex items-center gap-2 rounded-xl px-3 h-10 text-sm ${dark ? "bg-slate-800/50 text-slate-300" : "bg-slate-100 text-slate-700"}`} data-no-translate>
      <Globe className="w-4 h-4 shrink-0" />
      <select value={lang} onChange={change} className="flex-1 bg-transparent outline-none cursor-pointer" aria-label="Lingua / Language" data-testid={testid}>
        {LANGUAGES.map((l) => <option key={l.code} value={l.code} className="text-slate-900">{l.label}</option>)}
      </select>
    </label>
  );
}
